/** Configurazione del sito — un solo punto per nomi, dominio e contatti. */
export const site = {
  short: "CESP",
  name: "Centro Studi Pedagogici Don Lorenzo Milani",
  city: "Genova",
  domain: "cspdlm.it",
  url: "https://cspdlm.it",
  email: "info@cspdlm.it",
  referenceYear: 2026,
};

export interface RouteDef {
  path: string;
  key: string;
  testid: string;
  end?: boolean;
  children?: RouteDef[];
}

export const routes: RouteDef[] = [
  { path: "/", key: "nav.home", testid: "nav-link-home", end: true },
  { path: "/chi-siamo", key: "nav.chi_siamo", testid: "nav-link-chi-siamo" },
  { path: "/ambiti-di-ricerca", key: "nav.ambiti", testid: "nav-link-ambiti-di-ricerca" },
  {
    path: "/attivita",
    key: "nav.attivita",
    testid: "nav-link-attivita",
    children: [
      { path: "/attivita/iniziative", key: "nav.att_iniziative", testid: "nav-link-att-iniziative" },
      { path: "/attivita/lectiones", key: "nav.att_lectiones", testid: "nav-link-att-lectiones" },
      { path: "/attivita/master", key: "nav.att_master", testid: "nav-link-att-master" },
      { path: "/attivita/pubblicazioni", key: "nav.att_pubblicazioni", testid: "nav-link-att-pubblicazioni" },
    ],
  },
  { path: "/contatti", key: "nav.contatti", testid: "nav-link-contatti" },
];
